<template>
  <div class="tw-w-full tw-flex tw-flex-row tw-justify-start tw-items-center">
    <span
      class="tw-w-4 md:tw-w-16 tw-h-0.5 tw-bg-white tw-box-border tw-mr-5"
    ></span>
    <div class="tw-flex tw-flex-col tw-justify-start tw-items-start">
      <span
        class="tw-font-medium tw-uppercase tw-text-white tw-text-1.6 xl:tw-text-4xl md:tw-text-3xl"
        >{{ tagName }}</span
      >
      <span
        v-if="tagNumber"
        class="number tw-text-white tw-text-1.6 xl:tw-text-4xl md:tw-text-3xl tw-uppercase tw-font-medium"
        >{{ tagNumber }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "section-tag",
  props: ["tagName", "tagNumber"]
};
</script>

<style></style>
